export * from './InfoBeacon'
